import { userService } from "@services/UserServices";
import { toastService } from "@services/ToastService";
import { useNavigate } from "react-router-dom";

interface UserRole {
  id: number;
  name: string;
  description: string;
  ordering: number;
}
export const useUserService = () => {
  const navigate = useNavigate();

  const logout = async () => {
    try {
      await userService.logout();
      toastService.success("Logged out successfully");
      navigate("/login");
    } catch (error) {
      toastService.error("Failed to log out");
      throw error;
    }
  };
  const getCurrentUser = async () => {
    try {
      const user = await userService.getCurrentUser();
      return user;
    } catch (error) {
      console.error("Failed to fetch user data");
      throw error;
    }
  };
  const searchCompanyMembers = async (query: string, include_self = false) => {
    try {
      return await userService.searchCompanyMembers(query, include_self);
    } catch (error) {
      console.error("Failed to fetch users");
      throw error;
    }
  };
  const getRoles = async (type: "reports" | "projects") => {
    try {
      const response = await userService.getRoles(type);
      return response?.sort(
        (a: UserRole, b: UserRole) => a.ordering - b.ordering
      );
    } catch (error) {
      console.error("Failed to fetch roles");
      throw error;
    }
  };
  const checkCompanyExists = async (companyName: string): Promise<boolean> => {
    try {
      const response = await userService.checkCompanyExists(companyName);
      return response?.status === 200;
    } catch (error) {
      return false;
    }
  };
  const emailLogin = async (email: string) => {
    try {
      const response = await userService.emailLogin(email);
      return response;
    } catch (error) {
      throw error;
    }
  };

  return {
    logout,
    getCurrentUser,
    searchCompanyMembers,
    getRoles,
    checkCompanyExists,
    emailLogin,
  };
};
